import AlternatingImages from '../helpers/alternatingimages';

import pumac_2025 from '../images/2025-pumac.jpg';
import Sections from '../helpers/sections';
import PageTemplate from '../helpers/pagetemp';

function MyPUMaC() {

    var about_section = [
        <div className="spacious-text"> 
            The Princeton University Mathematics Competition (PUMaC) is a high school math competition held annually in November. The competition is run by students from Princeton University. It competition consists of several rounds, along with math talks annd mini-events.
        </div>
    ]
 
    var past_result_sections = AlternatingImages({
        sections: [
            {
                title: "",
                description: ( 
                    <>
                        <h5>2025</h5>
                        <p>
                            We sent a team to the PUMaC competition for the first time. Our team placed <span className="emphasized-text">26<sup>th</sup></span> overall, including placing <strong>14<sup>th</sup></strong> in the Power Round and <strong>26<sup>th</sup></strong> in the Team Round. <br /> <br />

                            <span className='team-text'>Team: Keshav Karumbunathan, Vihaan Paliwal, Anshul Mantri, Ashvant Daniel, Garud Shah, John Kong, Kevin Cheng, and Anirudh Thodupunuri. </span>
                        </p>
                    </>
                ),
                image: pumac_2025
            }
        ],
        key: "past-results"
    });

    var description_section = [
        <div className="spacious-text">
            The competition has 8-member teams, with four rounds: a team round, a power round, and two topic-based individual rounds (each competitor selects two from algebra, number theory, geometry, and combinatorics):
            <ul>
                <li><strong>Team Round:</strong> Computational problems in a fixed time interval, with amounts changing each year.</li>
                <li><strong>Power Round:</strong> Proof problems over the course of a week prior to the competition.</li>
                <li><strong>Individual Rounds:</strong> 8 problems in 60 minutes based on the category.</li>
            </ul>
        </div>
    ]

    var sections = [
        {
            "title": "About",
            "items": about_section, 
            enhance: true 
        },
        {
            "title": "Description", 
            "items": description_section, 
            enhance: true 
        },
        {
            "title": "Past Results",
            "items": past_result_sections, 
            enhance: true 
        }
    ];

    return <PageTemplate id="pumac-page">
        <h1 className="my-5">PUMaC</h1>
        <Sections sections={sections} title_block={({ children }) => <h4>{children}</h4>} />
    </PageTemplate>
}

export default MyPUMaC;
